import GeofenceForm from "./GeofenceForm"

export default  GeofenceForm;



// WEBPACK FOOTER //
// ./src/components/App/Geofence/GeofenceDetail/GeofenceForm/index.js